import React, { useCallback, useMemo } from 'react';

import { useTemplateStudioState } from 'state/hooks/template-studio.hook';

import { MultiSelect } from 'components/MultiSelect/MultiSelect';
import { EThemes } from 'components/TemplatesStudio/enums';
import { FormControl, FormItem, FormMessage } from 'components/ui';

export const ThemesFormItem: React.FC<{
  onChange: (values: string[]) => void;
  value: string[];
}> = ({ onChange, value }) => {
  const { supportedThemes } = useTemplateStudioState();

  const themesOptions = useMemo(
    () =>
      supportedThemes!.map((theme: EThemes) => ({
        value: theme,
        label: theme
          .replace(/-/g, ' ')
          .replace(/\b\w/g, (char: string) => char.toUpperCase())
      })),
    [supportedThemes]
  );

  const handleRenderValue = useCallback(
    (selected: string[]) => {
      const knownSelected = selected.filter((s) =>
        themesOptions.some((o) => o.value === s)
      );
      if (
        knownSelected.length === themesOptions.length ||
        knownSelected.length === 0
      )
        return 'All';
      if (knownSelected.length === 1) {
        return (
          themesOptions.find((o) => o.value === knownSelected[0])?.label ||
          knownSelected[0]
        );
      }
      return knownSelected
        .map(
          (item) => themesOptions.find((o) => o.value === item)?.label || item
        )
        .join(', ');
    },
    [themesOptions]
  );

  return (
    <FormItem>
      <FormControl>
        <div className="flex items-center justify-between mt-2">
          <span className="text-xs text-black whitespace-nowrap">Themes</span>
          <div className="w-[120px] text-xs">
            <MultiSelect
              options={themesOptions}
              value={(value as string[]) || []}
              onChange={onChange}
              placeholder="All"
              renderValue={handleRenderValue}
              buttonClassName="h-[30px]"
              iconClassName="text-xs text-base-mutedForeground"
            />
          </div>
        </div>
      </FormControl>
      <FormMessage />
    </FormItem>
  );
};
